export const siteName = 'lge-svpc';
export const defaultDesktopViewer = 'carousel';
export const loginBoxStyles = { width: 400, borderRadius: 16, padding: '56px 40px' };
export { LoginExtraForms, Login } from './components';
export const protocolHandler = true;
export const onMyInfoPasswordChange = false; // 내정보 > 비밀번호 변경 기능 사용 유무 #201733
